//
// APP - 配置
//
// APP - 开启店铺
let tmp_APP_OPEN_SHOP = true
// APP - 库存选取branch_ID
let tmp_APP_BRANCH_ID = 7
// APP - 全局打折
let tmp_APP_GLOBAL_DISCOUNT = 20
// APP - 通知消息
let tmp_APP_NOTICE_MESSAGE = "Welcome to MEGAPLUS"
// APP - 首页启动相对地址路径
let tmp_APP_HOME_RELATIVE_URL = "/category"
//
// 语言 - 配置
//
// 语言 - 是否只显示英文
let tmp_LANG_ONLY_ENGLISH = false
//
// 订单 - 配置
//
// 订单 - 开启周末下单
let tmp_APP_ENABLE_ORDER_WEEKEND = false
// 订单 - 开启当日最迟下单时间
let tmp_APP_ENABLE_ORDER_BEFORE_TIME = "09:00"
// 订单 - 最小下单日期
let tmp_APP_MIN_ORDER_DATE = "2025-04-28"
// 订单 - 最大选取日期天数(0表示1天, 1表示2天...)
let tmp_APP_MAX_ORDER_DAYS = 0
//
// 注册 - 配置
//
// 注册 - 开启手机注册
let tmp_REGISTER_FIELD_PHONE_ENABLE = true
// 注册 - 手机号必填
let tmp_REGISTER_FIELD_PHONE_REQUIRED = true

export const appConfig = {
    // APP
    APP_OPEN_SHOP: tmp_APP_OPEN_SHOP,
    APP_BRANCH_ID: tmp_APP_BRANCH_ID,
    APP_GLOBAL_DISCOUNT: tmp_APP_GLOBAL_DISCOUNT,
    APP_NOTICE_MESSAGE: tmp_APP_NOTICE_MESSAGE,
    APP_HOME_RELATIVE_URL: tmp_APP_HOME_RELATIVE_URL,
    // LANGUAGE
    LANG_ONLY_ENGLISH: tmp_LANG_ONLY_ENGLISH,
    // ORDER
    APP_ENABLE_ORDER_WEEKEND: tmp_APP_ENABLE_ORDER_WEEKEND,
    APP_ENABLE_ORDER_BEFORE_TIME: tmp_APP_ENABLE_ORDER_BEFORE_TIME,
    APP_MIN_ORDER_DATE: tmp_APP_MIN_ORDER_DATE,
    APP_MAX_ORDER_DAYS: tmp_APP_MAX_ORDER_DAYS,
    // REGISTER
    REGISTER_FIELD_PHONE_ENABLE: tmp_REGISTER_FIELD_PHONE_ENABLE,
    REGISTER_FIELD_PHONE_REQUIRED: tmp_REGISTER_FIELD_PHONE_REQUIRED
}
